import { render, staticRenderFns } from "./VerkaContactCard.vue?vue&type=template&id=e1c78718&scoped=true&"
import script from "./VerkaContactCard.vue?vue&type=script&lang=ts&"
export * from "./VerkaContactCard.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaContactCard.vue?vue&type=style&index=0&id=e1c78718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c78718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VSpacer})
